import React from 'react';
import PropTypes from 'prop-types';
import ActionButton from '../../../action-button';
import { iconsList } from '../../../icon/glyphs';

const PaginationButton = ({
  label = '',
  iconGlyph = null,
  selected = false,
  disabled = false,
  onClick,
}) => (
  <ActionButton
    size="small"
    label={label}
    iconGlyph={iconGlyph}
    selected={selected}
    disabled={disabled}
    onClick={onClick}
  />
);

PaginationButton.propTypes = {
  label: PropTypes.string,
  iconGlyph: PropTypes.oneOf(iconsList),
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

export default PaginationButton;
